import React from "react";
import { Container, Row, Col } from "react-bootstrap";
const WhyUs = () => {
  return (
    <div style={{ padding: "100px 0px" }}>
      <Container>
        <Row>
          
          <Col md={6}>
            <div className="about-us-home-divs">
              <h2 className="heading-section-one">
                Why Choose Surgery Saathi?
              </h2>
              <h5 className="heading-five-sectionOne">
                Safe, Expert Cosmetic Surgery You Can Trust
              </h5>
              <p className="sectionOne-paraa-one">
                At Surgery Saathi, our focus is on you. From reshaping your nose
                to flattening your chest or removing lumps, we offer
                personalized care from experienced doctors to help you feel more
                confident.
              </p>
              <div className="choose-about-wrap">
                <div
                  className="choose-about style2 wow fadeInUp"
                  style={{ visibility: "visible", animationName: "fadeInUp" }}
                >
                  <div className="choose-about_icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/15808/15808946.png?ga=GA1.1.12114912.1717589849"
                      alt="image"
                      className="why-us-imagess"
                    />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title why-choose-use-heading">
                      Skilled Surgeons
                    </h3>
                    <p className="choose-about_text">
                      Our doctors are experts in cosmetic surgery.
                    </p>
                  </div>
                </div>
                <div
                  className="choose-about style2 wow fadeInUp"
                  style={{ visibility: "visible", animationName: "fadeInUp" }}
                >
                  <div className="choose-about_icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/15305/15305779.png?ga=GA1.1.12114912.1717589849"
                      alt="image"
                      className="why-us-imagess"
                    />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title why-choose-use-heading">
                      Cutting-Edge Technology
                    </h3>
                    <p className="choose-about_text">
                      We use the latest tools and techniques to ensure safe
                      surgeries.
                    </p>
                  </div>
                </div>
                <div
                  className="choose-about style2 wow fadeInUp"
                  style={{ visibility: "visible", animationName: "fadeInUp" }}
                >
                  <div className="choose-about_icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/3098/3098231.png?ga=GA1.1.12114912.1717589849"
                      alt="image"
                      className="why-us-imagess"
                    />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title why-choose-use-heading">
                      Full Support
                    </h3>
                    <p className="choose-about_text">
                      From the first consultation to your final check-up, we’re
                      with you all the way.
                    </p>
                  </div>
                </div>
                <div
                  className="choose-about style2 wow fadeInUp"
                  style={{ visibility: "visible", animationName: "fadeInUp" }}
                >
                  <div className="choose-about_icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/15805/15805654.png?ga=GA1.1.12114912.1717589849"
                      alt="image"
                      className="why-us-imagess"
                    />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title why-choose-use-heading">
                      Safe Hospitals
                    </h3>
                    <p className="choose-about_text">
                      We only work with the best hospitals for your safety.
                    </p>
                  </div>
                </div>
              </div>

              {/* <a className="th-btn style2">Book Your Consultant</a> */}
            </div>
          </Col>
          <Col md={6}>
            <img
              src="https://img.freepik.com/premium-photo/view-from-four-multi-ethnic-surgeons-protective-work-wear-operation_124865-10352.jpg?w=900"
              // src="https://img.freepik.com/free-photo/young-woman-getting-lip-fillers-clinic_23-2149341860.jpg?t=st=1729667382~exp=1729670982~hmac=0ce9230cbe9b79cf9d967f5a4110922db0e1fdbbd6684758cfb1a1cc4b87a78c&w=740"
              alt=""
              className="about-us-two-img"
              style={{marginLeft:'0px'}}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WhyUs;
